/**
 * Trigger: tr_accounts_hard_delete
 * Purpose: Cascade delete and update positions when an account is hard deleted
 * Table: accounts
 * Event: BEFORE DELETE
 */
export const TR_ACCOUNTS_HARD_DELETE = `
CREATE TRIGGER tr_accounts_hard_delete
BEFORE DELETE ON accounts
FOR EACH ROW
BEGIN
  DELETE FROM account_activity_dates WHERE account_id = old._id;
  DELETE FROM account_daily_balances WHERE account_id = old._id;
  DELETE FROM account_balances WHERE account_id = old._id;
  DELETE FROM account_transfers WHERE account_in_id = old._id OR account_out_id = old._id;
  DELETE FROM creditors WHERE account_id = old._id;
  DELETE FROM debtors WHERE account_id = old._id;
  DELETE FROM exchanges WHERE account_id = old._id;
  DELETE FROM incomes WHERE account_id = old._id;
  DELETE FROM expenses WHERE account_id = old._id;
  DELETE FROM planned_expenses WHERE account_id = old._id;
  DELETE FROM planned_incomes WHERE account_id = old._id;
  DELETE FROM account_initial_balances WHERE account_id = old._id;
  DELETE FROM debtor_payments WHERE account_id = old._id;
  DELETE FROM creditor_payments WHERE account_id = old._id;

  UPDATE accounts
  SET position = position - 1,
      updated_at = strftime('%s', 'now')
  WHERE position > old.position
    AND is_deleted = 0;
END;
`;
